import * as types from './mutation-types'

export const storeTwilio = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/messaging/provider', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadTwilio = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/messaging/settings').then((response) => { 
            commit(types.ADD_TWILIO, response.data)       
        }).catch((err) => {
            reject(err)
        })
    })
}

